var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZerodha = function SvgZerodha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 90 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f6461a",
    d: "M30 0 0 30l30 30 30-30L90 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#db342c",
    d: "m30 60 30-30 30 30z"
  })));
};
export { SvgZerodha as ReactComponent };
export default __webpack_public_path__ + "725331c2c75b24d6b11dc0e56eec091a.svg";